import React, {Component} from 'react'
import {Redirect} from 'react-router-dom'
import {Helmet} from "react-helmet";


class ProjectPage extends Component {
	componentWillMount() {
		document.body.className = 'single-project'
		const random = Math.floor(Math.random() * (3 - 1 + 1) + 1)
		const imageName = `BG_single_0${random}`
		document.body.style.backgroundImage = `url(/img/${imageName}.jpg)`
	}

	componentWillUnmount() {
		document.body.style = ""
	}

	render() {
		if (!this.props.dataLoaded) return <main></main>
		const item = this.props.projects.find(project => project.title === this.props.match.params.id)
		if (!item) return <Redirect to="/"/>

		return (
			<main>
				<Helmet>
					<title>{item.heading} | Tokariev Sviatoslav's workshop</title>
				</Helmet>
				<h1 className="heading--single">{item.heading}</h1>
				<div className="single-project__wrapper">
					<div className="single-project__row">
						<div className="single-project__image">
							<img src={item.project.imgFirst.src} alt={item.project.imgFirst.alt}/>
						</div>
						<div className="single-project__description single-project__description--white">
							<h2 className="single-project__heading">Description</h2>
							{item.project.paragraphs.map((text,key)=>
								<p className="single-project__text" key={key} dangerouslySetInnerHTML={{__html:text}}></p>)
							}
							<h2 className="single-project__heading single-project__heading--mb075">Technologies</h2>
							<ul className="single-project__list">
								{item.project.technologies.map((text,key)=><li key={key}>{text}</li>)}
							</ul>
						</div>
					</div>
					<div className="single-project__row--second">
						<div className="single-project__description">
							<div>
								<h2 className="single-project__heading">Features</h2>
								<h3 className="single-project__subheading">{item.project.featuresSubh}</h3>
								<ul className="single-project__list">
									{item.project.features.map((text,key)=><li key={key}>{text}</li>)}
								</ul>
							</div>
							<div className="single-project__buttons">
								{item.project.link ?
									<a className="button--bordered" href={item.project.link} target="_blank"
									   rel="noopener noreferrer">
										To project
									</a> : null}
							</div>
						</div>
						<div className="single-project__image">
							<img src={item.project.imgSecond.src} alt={item.project.imgSecond.alt}/>
						</div>
					</div>
				</div>
			</main>
		)
	}

}

export default ProjectPage



// WEBPACK FOOTER //
// ./src/containers/ProjectPage.js